/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrMedicalExpenseTypename = "PhrMedicalExpense" as const;

/**
 *
 * @export
 * @interface PhrMedicalExpense
 */
export interface PhrMedicalExpense {
  /**
   *
   * @type {number}
   * @memberof PhrMedicalExpense
   */
  amount?: number;
  /**
   *
   * @type {string}
   * @memberof PhrMedicalExpense
   */
  medicalInstitutionName?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrMedicalExpense
   */
  readonly __typename?: string;
}

export function PhrMedicalExpenseFromJSON(json: any): PhrMedicalExpense {
  return PhrMedicalExpenseFromJSONTyped(json, false);
}

export function PhrMedicalExpenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrMedicalExpense {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrMedicalExpenseTypename,

    amount: !exists(json, "amount") ? undefined : json["amount"],
    medicalInstitutionName: !exists(json, "medical_institution_name") ? undefined : json["medical_institution_name"],
  };
}

export function PhrMedicalExpenseToJSON(object?: PhrMedicalExpense | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    amount: value.amount,
    medical_institution_name: value.medicalInstitutionName,
  };
}
